import { render, staticRenderFns } from "./SettingCamLists.vue?vue&type=template&id=3b1d17e4&"
import script from "./SettingCamLists.vue?vue&type=script&lang=js&"
export * from "./SettingCamLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports